<div class="card card-warning d-flex flex-row justify-content-start align-items-center shadow-none mb-3">
  <mat-icon>report_problem</mat-icon>
  <div class="d-flex flex-column">
    <div class="f-14 color-default">
      <ng-content></ng-content>
    </div>
  </div>
</div>
